import * as React from 'react';

import { IDailyFormState } from '.';
import { questionData } from '../../../constants/generals';
import { DailyFormsModel } from '../../../model/DailyFormModel';
import { Form } from '../../reusableComponents/FormComponents/Form';
import { FormFooter } from '../../reusableComponents/FormComponents/FormFooter';
import { InputRow } from '../../reusableComponents/FormComponents/InputRow';
import { QuestionRow } from '../../reusableComponents/FormComponents/QuestionRow';
import { ImageUpload } from '../../reusableComponents/ImageUpload';
import { RenderQuestion } from '../../reusableComponents/FormComponents/RenderQuestion';
import { dispatch } from '../../../utils/generalUtils';
import { actions } from 'react-redux-form';
// import * as PropTypes from 'prop-types';
import * as PropTypes from 'prop-types';

export interface ICreateFormProps {
    state: IDailyFormState;
    handleSubmit: (values) => void;
    loadDefaultValues: Function;
    instance: DailyFormsModel;
    formId?: string; 
}
export interface ICreateFormsState {
    questions: {
        Question_Num: number,
        Question: string
        , Questiontype? : string,
        containsComment?: boolean,
        CommentQuestion?: string,
        CommentQuestionNum?: number,
        CommentQuestionLabel?: string,
        customLabelForComments?: string;
    }[];
    isPlantOperatingToday?: boolean;
}
export class CreateForm extends React.PureComponent<ICreateFormProps, ICreateFormsState> {
    constructor(props: ICreateFormProps) {
        super(props);
        this.state = {
            questions: questionData.slice(0, 2),
            isPlantOperatingToday: false,
        };
    }

    refs: {
        images: ImageUpload;
    };

    get value() {
        return this.refs.images.value;
    }
    getChildContext() {
        return { formModel: 'forms.dailyForm' };
    } 

    static childContextTypes = {
        formModel: PropTypes.string
    };
    renderingDailyFormQuestion = (isPlantOperatingToday, quesNo) => {
        if (isPlantOperatingToday === 'Yes' && quesNo === '3') {
            this.setState({ questions: questionData });
        }
        if (isPlantOperatingToday === 'No' && quesNo === '3') {
            this.setState({ questions: questionData.slice(0, 2) });
            for (let index = 4; index < 18; index++) {
                dispatch(actions.change(`forms.dailyForm.${index}`, null));   
            }
        }
        
    }

    loadValues = () => {
        if (this.props.instance) {
            const { questions } = this.props.instance.props;
            if (questions[5].answer === 'Yes') {
                this.setState({ questions: questionData });
            } else {
                this.setState({questions: questionData.slice(0, 2)});
            }
        }

        this.props.loadDefaultValues();
    }

    render() {
        const Buttons = [ { 
            label : 'Yes',
            value : 'Yes'
        }, 
        {
            label: 'No',
            value: 'No'
        }
    ];
        return <Form
            model="forms.dailyForm"
            onSubmit={this.props.handleSubmit}
            className=""
            loadDefaultValues={this.loadValues}
        >
            {this.state.questions && this.state.questions.map((quesData, index) => (
                <RenderQuestion
                    key={index}
                    formId={this.props.formId}
                    onChange={this.renderingDailyFormQuestion}
                    uniqueValue={index}
                    quesNo={quesData.Question_Num && quesData.Question_Num.toString()}
                    question={quesData.Question}
                    questionType={quesData.Questiontype}
                    model="dailyForm"
                    containsComment={quesData.containsComment ? true : false}
                    CommentQuestion={quesData.CommentQuestion ? quesData.CommentQuestion : ''}
                    CommentQuestionNum={quesData.CommentQuestion ? quesData.CommentQuestionNum : null}
                    CommentQuestionLabel={quesData.CommentQuestionLabel ? quesData.CommentQuestionLabel : ''}
                    customLabelForComments={quesData.customLabelForComments ? 
                        quesData.customLabelForComments.toString() : ''}
                    buttons={Buttons}
            />
            ))
            }
            <ImageUpload
                ref="images"
                multi={true}
                label="Select Images to Upload:"
                defaultValue={this.props.instance && this.props.instance.props.ImageUrls }
            />
            <FormFooter />
        </Form>;

    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Forms/DailyForm/CreateForm.tsx